import i18next from "i18next";

const PageUnknown = () => {

    return (
        <div className="fixed-center">
            <div className="text-center">
                <h1>{ i18next.t("unknown.title") }</h1>
                <p>{ i18next.t("unknown.description") }</p>
            </div>
        </div>
    );
}

export default PageUnknown;